<template>

</template>

<script>
  import {
    Overlay
  } from 'vant';
  export default {
    components: {
      [Overlay.name]: Overlay,
    },
    data() {
      return {

      };
    },
    created() {
      // var url = storage.getItem('url'); wxad649039f42e14ca
      var appid = this.$route.query.appid;
      var storage = window.sessionStorage;
      storage.setItem('appid', appid);
      // https%3A%2F%2Fh5.xiaobaikaoyan.com%2F%23%2Fvip
      let redirect_url = encodeURIComponent(location.origin + "/#/vip");
      console.log("appid", appid, redirect_url)
      let url =
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_base`;
      // let storage = window.sessionStorage;
      // let Openid = storage.getItem('Openid')

      // if(!Openid){
      window.location.href = url
      // }else{
      // 	this.$router.push({
      // 		name: 'vip',
      // 		query: {
      // 			Openid,
      // 		}
      // 	})
      // }

    },
    methods: {
      query1(name) {
        const search = location.search.substr(1); // 得到类似于 a=10&b=20&c=30
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i'); // i 忽略大小写
        const res = search.match(
        reg); // 返回格式 0: "a=10&" 1: "" 2: "10" 3: "&" groups: undefined index: 0 input: "a=10&b=20&c=30"
        if (res === null) {
          return null
        }
        return res[2];
      },
    }
  }
</script>

<style>
</style>
